export const TARGET = 100;

export const TOKEN = "passcode";

export const BBDC_ENDPOINT = "https://rproxy.learningman.top/bbdc";

export const KV_ENDPOINT = "https://rproxy.learningman.top/kv";
